<template>
  <div v-if="campania" class="novedad-campana grey lighten-5" data-test="novedad-campana">
    <div class="novedad-campana-icono grey lighten-3">
      <v-icon small class="primary--text text--darken-2">mdi-bullhorn-outline</v-icon>
    </div>
    <div class="novedad-campana-cuerpo">
      <div class="d-flex align-center novedad-campana-encabezado">
        <v-chip x-small label color="primary" class="white--text novedad-campana-chip">Novedad</v-chip>
        <span class="novedad-campana-cuando">hoy</span>
      </div>
      <div class="novedad-campana-titulo">{{ campania.titulo }}</div>
      <div v-if="campania.texto" class="novedad-campana-texto">{{ campania.texto }}</div>
      <a class="novedad-campana-ver primary--text text--darken-2" data-test="novedad-ver" @click.prevent="ir">
        {{ campania.boton_texto || "Ver" }}
      </a>
    </div>
    <v-btn icon x-small aria-label="Cerrar" data-test="novedad-cerrar" @click="cerrar">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { abrirEnlaceCampania } from "@/utils/publicidadEnlace";

/**
 * Fila destacada al tope del desplegable de la campana. Lee la campaña de tipo
 * "campana" del store y no renderiza nada si no hay. Solo comparte el lugar con las
 * notificaciones: el dato vive en la plataforma, no en las notificaciones del comercio.
 */
export default {
  name: "NovedadCampana",
  computed: {
    campania() {
      const porTipo = this.$store.getters["publicidad/porTipo"] || {};
      return porTipo.campana || null;
    },
  },
  watch: {
    campania: {
      immediate: true,
      handler(campania, anterior) {
        if (campania && (!anterior || anterior.id !== campania.id)) {
          this.$store.dispatch("publicidad/verVista", campania.id);
        }
      },
    },
  },
  methods: {
    ir() {
      this.$store.dispatch("publicidad/clic", this.campania.id);
      abrirEnlaceCampania(this.campania.boton_url);
    },
    cerrar() {
      this.$store.dispatch("publicidad/cerrar", this.campania.id);
    },
  },
};
</script>

<style scoped>
.novedad-campana {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 8px 12px 12px;
  border-left: 3px solid var(--v-primary-base);
}
.novedad-campana-icono {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.novedad-campana-cuerpo {
  flex: 1 1 auto;
  min-width: 0;
}
.novedad-campana-encabezado {
  gap: 8px;
}
.novedad-campana-chip {
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.novedad-campana-cuando {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
}
.novedad-campana-titulo {
  font-size: 13px;
  font-weight: 600;
  margin-top: 4px;
}
.novedad-campana-texto {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.35;
}
.novedad-campana-ver {
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}
</style>
